import {combineReducers} from "redux";
import locale from "store/reducers/locale";
import dialog from "store/reducers/dialog";
import codeEditor from "store/reducers/codeEditor";
import asset from "store/reducers/asset";
import mode from "store/reducers/mode";
import tutorial from "store/reducers/tutorial";
import transform from "store/reducers/transform";
import layer from "store/reducers/layer";
import helper from "store/reducers/helper";
import grid from "store/reducers/grid";
import userinfo from "store/reducers/userInfo";
import undoredo from "store/reducers/undoredo";
import progress from "store/reducers/progress";
import selfie from "store/reducers/selfie";
import chat from "store/reducers/chat";
import voiceChat from "store/reducers/voiceChat";
import audioPlayer from "store/reducers/audioPlayer";
import playOption from "store/reducers/playOption";
import alertPopup from "store/reducers/alertPopup";
import avatar from "store/reducers/avatar";
import animationBar from "store/reducers/animationBar";
import assetLibrary from "store/reducers/assetLibrary";
import autoSave from "store/reducers/autoSave";
import sceneInfo from "store/reducers/sceneInfo";
import game from "./game";
import template from "./template";
import ad from "./ad";
import snsInfo from "./snsInfo";
import sidePanel from "./sidePanel";
import playData from "./playData";
import version from "./version";
import propertyPanel from "./propertyPanel";

export default combineReducers({
  locale,
  dialog,
  codeEditor,
  asset,
  mode,
  tutorial,
  transform,
  layer,
  helper,
  grid,
  undoredo,
  userinfo,
  progress,
  selfie,
  chat,
  voiceChat,
  audioPlayer,
  playOption,
  alertPopup,
  avatar,
  animationBar,
  assetLibrary,
  game,
  autoSave,
  sceneInfo,
  template,
  ad,
  snsInfo,
  sidePanel,
  playData,
  version,
  propertyPanel,
});
